export const LogoMark = ({ className = "w-7 h-7" }) => (
  <img
    src="/media/logo-mark.png"
    alt="SANTELQ shield"
    className={`${className} object-contain`}
  />
);

export const Logo = () => (
  <a href="/" data-testid="logo-link" className="flex items-center group">
    <img
      src="/media/logo-full.png"
      alt="SANTELQ"
      className="h-6 sm:h-7 object-contain transition-transform duration-500 group-hover:scale-[1.03]"
    />
  </a>
);
